<template>
  <div class="menu_schedules--schedule">
    <div class="menu_schedules--schedule__header">
      <h3>{{ normalizedSchedule.schedule_title }}</h3>
    </div>
    <div class="menu_schedules--schedule_body">
      <div class="menu_schedules--schedule_body_item">
        <span>Applies To:</span>
        <span>{{ scheduleAppliesToMenuTypes }}</span>
      </div>

<!--      <div class="menu_schedules&#45;&#45;schedule_body_item">
        <span>Days of the Week</span>
        <span v-if="normalizedSchedule.schedule_days_of_week.length">{{ normalizedSchedule.schedule_days_of_week }}</span>
        <span v-else>Everyday</span>
      </div>-->

<!--      <div v-if="normalizedSchedule.schedule_day_start_time === 0 && normalizedSchedule.schedule_day_end_time === 2400"
           class="menu_schedules&#45;&#45;schedule_body_item">
        <span>Day Start Time</span>
        <span>All Day</span>
      </div>
      <div v-else class="menu_schedules&#45;&#45;schedule_body_item">
        <span>Day Start Time</span>
        <span>{{ normalizedSchedule.schedule_day_start_time }}</span>
      </div>-->

<!--      <div v-if="normalizedSchedule.schedule_day_start_time === 0 && normalizedSchedule.schedule_day_end_time === 2400"
           class="menu_schedules&#45;&#45;schedule_body_item">
        <span>Day End Time</span>
        <span>All Day</span>
      </div>
      <div v-else class="menu_schedules&#45;&#45;schedule_body_item">
        <span>Day End Time</span>
        <span>{{ normalizedSchedule.schedule_day_end_time }}</span>
      </div>-->

      <div class="menu_schedules--schedule_body_item">
        <span>Start Date/Time</span>
        <span v-html="scheduleStartDateTime"></span>
      </div>
      <div class="menu_schedules--schedule_body_item">
        <span>End Date/Time</span>
        <span v-html="scheduleEndDateTime"></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue'
import {MenuScheduleNormalized} from "../defs";

export default defineComponent({
  name: "ScheduleDisplay",
  props: {
    normalizedSchedule: {
      type: Object as PropType<MenuScheduleNormalized>,
      required: true,
    },
  },
  computed: {
    scheduleAppliesToMenuTypes(): string {
      const output = [];
      if (this.normalizedSchedule.schedule_is_textual) {
        output.push('Textual (Outlet Page)');
      }
      if (this.normalizedSchedule.schedule_is_visual) {
        output.push('Visual (iPad)');
      }

      if (output.length) {
        return output.join(', ');
      }

      return 'None';
    },

    scheduleStartDateTime(): string {
      if (this.normalizedSchedule.schedule_start_datetime) {
        return window.pepDateFunctions.formatDateTimeReadable(new Date(this.normalizedSchedule.schedule_start_datetime));//.replace(' at ', '<br>@ ');
      }

      return 'No Limitation';
    },
    scheduleEndDateTime(): string {
      if (this.normalizedSchedule.schedule_end_datetime) {
        return window.pepDateFunctions.formatDateTimeReadable(new Date(this.normalizedSchedule.schedule_end_datetime));//.replace(' at ', '<br>@ ');
      }

      return 'No Limitation';
    },
  },
})
</script>

<style scoped>
.menu_schedules--schedule {
  padding: 0.5em;
  transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1)
}

.menu_schedules--schedule-active {
  background-color: rgba(0, 128, 0, 0.54);
}

.menu_schedules--schedule + .menu_schedules--schedule {
  padding-top: 1em;
  border-top: 1px solid rgba(0, 0, 0, 0.54);
}

.menu_schedules--schedule_body_item {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 1em;
}

.menu_schedules--schedule_body_item span:first-child {
  color: rgba(0, 0, 0, 0.67);
  text-align: right;
}
</style>